import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";

import FlagSelector from "../FlagSelector";
import Mention from "../Mention";
import { Icon, Button } from "antd";
import DefaultUserImage from "../../assets/img/avatar_user_black.png";
import { ReactComponent as AtSvg } from "../../assets/icon/ic_at_24dp.svg";

import { debounce } from "../../utils/debounce";
import UserService from "../../services/user";
import "./MessageInput.scss";

import { updateChat } from "../../store/actions/chats";
import { isTruthy } from "../../utils/util";
import keyCode from "../../constants/keyCode";

class MessageInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      valueHtml: "",
      users: [],
      loadingUsers: false,
      sendingMessage: false,
      searchValue: "",
      suggestionsLength: 0,
    };

    this.onKeyDown = this.onKeyDown.bind(this);
    this.send = this.send.bind(this);
  }

  componentDidMount() {
    const { initialState, chat, updateChat } = this.props;

    this.mounted = true;

    const localInitialState = initialState || "";

    this.setState(
      {
        value: localInitialState,
      },
      () => this.debounceChange(localInitialState)
    );

    if (chat.focusOnOpen) {
      this.mention.setFocus();
      updateChat({ id: chat.id, focusOnOpen: false });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.chatState === "" &&
      this.props.chatState !== prevProps.chatState &&
      this.mounted
    ) {
      this.setState(
        {
          value: "",
        },
        () => this.mention && this.mention.clear && this.mention.clear()
      );
    }
    if (
      this.props.waitingMessageSentConfirmation === false &&
      prevProps.waitingMessageSentConfirmation === true
    ) {
      this.mention.node.contentEditable = true;
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.debounceChange.clear();
    this.debounceUserSearchChange.clear();
  }

  fetchUsers(params = {}, callback) {
    UserService.getUsers(params).then(callback);
  }

  isValidInput(value) {
    return value.trim().length > 0;
  }

  onChange(html, text) {
    if (this.mounted) {
      const chatConfig = window.Social.getChatConfig();
      if ((text && text.length) < (chatConfig && chatConfig.messageMaxLength)) {
        this.setState({
          value: text,
          valueHtml: html,
        });
      }

      this.debounceChange(html);
    }
  }

  debounceChange = debounce((value) => {
    if (this.mounted) {
      this.props.onChange && this.props.onChange(value);
    }
  }, 250);

  getUserAvatar(user) {
    return DefaultUserImage;
  }

  debounceUserSearchChange = debounce((searchValue, callback) => {
    const { chat } = this.props;
    const { formatMessage } = this.props.intl;
    const chatConfig = window.Social.getChatConfig();
    const paths = chatConfig.chatRecipientsUsernamePath;
    const privacyConfig = Object.values(window.Social.getPrivacyTypesConfig());
    const currentChatHashElement =
      chat &&
      chat.elements &&
      chat.elements.find(
        (elem) => elem.description === chatConfig.hashElementPrefix
      );
    const currentChatPrivacyElement =
      chat &&
      chat.elements &&
      chat.elements.find(
        (elem) => elem.description === chatConfig.privacyElement
      );
    const currentChatPrivacy = currentChatPrivacyElement
      ? privacyConfig.find(
          (elem) => elem.value === currentChatPrivacyElement.content
        )
      : privacyConfig.find((elem) => elem.isDefault);
    let profiles = [];

    if (currentChatHashElement) {
      profiles = this.props.profiles.map((elem) => {
        return {
          key: elem,
          value: formatMessage({ id: `profiles.${elem}` }),
          usernameAlias: formatMessage({ id: `profiles.${elem}` }),
        };
      });

      profiles = profiles.filter((elem) => {
        return (
          elem.value &&
          (elem.value.toLowerCase().includes(searchValue.toLowerCase()) ||
            elem.key.toLowerCase().includes(searchValue.toLowerCase()))
        );
      });
    }

    if (
      currentChatPrivacy &&
      currentChatPrivacy.onlyCurrentUsersOnMention &&
      !chat.newChat
    ) {
      this.setState({
        loadingUsers: true,
      });

      let recipients = chat.recipients.filter((elem) => {
        for (let i = 0, pathsLength = paths.length; i < pathsLength; i++) {
          elem = elem[paths[i]];
        }

        return elem && elem.toLowerCase().includes(searchValue.toLowerCase());
      });

      let suggestions =
        recipients &&
        recipients.map((value) => {
          let suggestion = value;

          for (let i = 0, pathsLength = paths.length; i < pathsLength; i++) {
            suggestion = suggestion[paths[i]];
          }

          return {
            key: suggestion,
            value: suggestion,
          };
        });

      suggestions = [].concat(profiles, suggestions);

      this.setState({
        searchValue,
        loadingUsers: false,
        suggestionsLength: suggestions.length,
      });

      return callback(suggestions);
    } else {
      if (searchValue.length > 0) {
        this.setState({
          loadingUsers: true,
        });

        this.fetchUsers({ name: searchValue }, (res) => {
          let suggestions =
            res &&
            res.data &&
            res.data.content.map((suggestion) => {
              return {
                key: suggestion.username,
                value: suggestion.name,
              };
            });

          suggestions = [].concat(profiles, suggestions);

          this.setState({
            searchValue,
            loadingUsers: false,
            suggestionsLength: suggestions.length,
          });

          return callback(suggestions);
        });
      }
    }
  }, 500);

  onKeyDown(e) {
    const { pressEnterToSendMessage } = this.props.settings;

    const pressedEnter = e.keyCode === keyCode.ENTER;
    const shiftKeyIsPressed = e.shiftKey;

    const userHitEnterToSubmit = [
      pressEnterToSendMessage,
      this.canSendMessage(),
      pressedEnter,
      !shiftKeyIsPressed,
    ].every(isTruthy);

    if (userHitEnterToSubmit) {
      this.send();
    }
  }

  mapUsers() {
    return this.state.users.map((elem) => elem.username);
  }

  send() {
    if (this.canSendMessage() && this.isValidInput(this.state.value)) {
      this.mention.node.contentEditable = false;
      this.setState(
        {
          sendingMessage: true,
        },
        () => {
          setTimeout(() => {
            this.setState(
              {
                sendingMessage: false,
              },
              () =>
                this.props.sendMessage(
                  this.state.value,
                  this.mention.getMentions()
                )
            );
          }, 300);
        }
      );
    }
  }

  removeReactivity(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  getMentionsOptions() {
    return {
      collection: [
        {
          trigger: "@",
          lookup: "key",
          fillAttr: "key",
          requireLeadingSpace: true,

          values: (text, callback) => {
            this.debounceUserSearchChange(text, callback);
          },

          selectTemplate: (item) => {
            return `<span contenteditable="false" style="color: #1976D2" class="mention-user" data-user="${item.original.key}">@${item.original.key}</span>`;
          },

          menuItemTemplate: (item) => {
            const avatarSrc = this.getUserAvatar(item.original);
            return `<div class="list-item">
                      <div class="image"><img src="${avatarSrc}"/></div>
                      <div class="content">
                        <div class="title">@${
                          item.original.usernameAlias || item.original.key
                        }</div><div class="description">${
              item.original.value
            }</div>
                      </div>
                    </div>`;
          },
        },
      ],
    };
  }

  onAtClick() {
    if (this.state.value && this.state.value.length)
      this.mention.insertTextAtEnd(`@`, false);
    else this.mention.insertTextAtEnd(`&nbsp;@`, false);
  }

  onHashClick() {
    if (this.state.value && this.state.value.length)
      this.mention.insertTextAtEnd(`#`, false);
    else this.mention.insertTextAtEnd(`&nbsp;#`, false);
  }

  canSendMessage() {
    if (!this.props.canSendMessage) {
      return false;
    }

    if (this.state.sendingMessage) {
      return false;
    } else if (
      this.isValidInput(this.state.value) &&
      this.props.canSendMessage
    ) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const chatConfig = window.Social.getChatConfig();

    let MentionContainer = (
      <div
        className="message-input"
        key="message-input"
        onKeyDown={this.onKeyDown}
        onClick={this.props.onFocus}
        ref={(node) => (this.mentionContainerRef = node)}
      >
        <Mention
          className="multiple"
          ref={(node) => (this.mention = node)}
          onInputChange={this.onChange.bind(this)}
          options={this.getMentionsOptions()}
          inputType={`multiple ${this.props.newChat ? "full" : ""}`}
          placeholder={this.props.intl.messages["chat.typeMessage"]}
          dropdownClass="top"
          defaultValue={this.props.initialState}
          suggestionsLength={this.state.suggestionsLength}
          readOnly={this.props.readOnly}
        />
        <div
          className="dropdown-container"
          ref={(node) => (this.dropdownContainerRef = node)}
        />
      </div>
    );

    let MessageInputButtons = (
      <div className="message-input-buttons" key="message-input-buttons">
        <div className="action-buttons">
          <Icon
            className="action-button"
            component={AtSvg}
            onClick={this.onAtClick.bind(this)}
          />
          {/* <Icon className="action-button" component={HashSvg} onClick={this.onHashClick.bind(this)}/> */}
        </div>
        {chatConfig.allowFlags && this.props.newChat && (
          <FlagSelector
            flags={this.props.flags}
            onFlagSelect={this.props.onFlagSelect}
          />
        )}
        <Button
          className={`send-message ${
            chatConfig.allowFlags && this.props.newChat
              ? ""
              : "margin-left-auto"
          }`}
          type="primary"
          loading={this.props.waitingMessageSentConfirmation}
          disabled={!this.canSendMessage()}
          onClick={this.send}
        >
          <FormattedMessage id="general.send" />
        </Button>
      </div>
    );

    return [MentionContainer, MessageInputButtons];
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.GeneralSettings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateChat: (chat) => dispatch(updateChat(chat)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MessageInput));
